export default "__VITE_ASSET__DKDMFzfP__"